import api from "../Api";
import { BaseService } from "../BaseService";

export class ProfileService extends BaseService {
  async me(): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`auth/me`, {}));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async uploadProfileImage(file: File): Promise<any[]> {
    try {
      const formData = new FormData();
      formData.append("file", file);
      return this.handleResponse(
        await api.post(`users/profile-image/upload`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async deleteProfileImage(): Promise<any[]> {
    try {
      return this.handleResponse(await api.delete(`users/profile-image/delete`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async updateUser(data: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.put(`users/update`, data));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listPaymentMethods(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`users/payments/methods/list`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async deletePaymentMethod(id: number): Promise<any[]> {
    try {
      return this.handleResponse(await api.delete(`users/payments/methods/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async setDefaultPaymentMethod(id: number): Promise<any[]> {
    try {
      return this.handleResponse(await api.patch(`users/payments/methods/set-default/${id}`, {}));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async addPaymentMethod(data: { stripe_payment_method_id: string; is_default: boolean; card_type?: string }): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`users/payments/methods/create`, data));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getActiveSubscription(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`users/active-subscription`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getActiveSessions(): Promise<any> {
    try {
      return this.handleResponse(await api.get(`plans/subscriptions/user/active-sessions`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async revokeSession(userId: number): Promise<any> {
    try {
      return this.handleResponse(await api.get(`plans/subscriptions/user/revoke-session/${userId}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
